import React, { useState, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import SupportTicketForm from '../components/support/SupportTicketForm';
import ArchiveOldTickets from '../components/support/ArchiveOldTickets';
import InboxWorkspace from '../components/inbox/InboxWorkspace';
import './CustomerSupportPage.css';

// Support = the unified inbox workspace (the classic Tickets / Chats / Abandoned screens were retired 11 Oct 2026)
function CustomerSupportPage() {
  const apiBase =
    typeof window !== 'undefined' && window.location.hostname === 'localhost'
      ? 'http://localhost:3001'
      : '';

  const { currentUser, canAccessPage, canPerformAction } = useAuth();
  const isAdmin = canAccessPage('admin');
  const canInbox = canPerformAction('support.viewTickets') || canPerformAction('support.viewLive') || canPerformAction('support.viewAbandoned');

  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showArchive, setShowArchive] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const getToken = useCallback(async () => {
    if (!currentUser) return null;
    return currentUser.getIdToken();
  }, [currentUser]);

  const triggerRefresh = useCallback(() => {
    setRefreshKey((k) => k + 1);
  }, []);

  const handleTicketCreated = useCallback(() => {
    setShowCreateForm(false);
    triggerRefresh();
  }, [triggerRefresh]);

  return (
    <div className="support-page support-page-workspace">
      <InboxWorkspace
        apiBase={apiBase}
        getToken={getToken}
        me={currentUser?.uid}
        perms={{
          inbox: canInbox,
          tickets: canPerformAction('support.viewTickets'),
          chats: canPerformAction('support.viewLive'),
          carts: canPerformAction('support.viewAbandoned'),
          agent: canPerformAction('support.aiAgentTab'),
          customers: canPerformAction('support.viewCustomers'),
          metrics: canPerformAction('support.viewMetrics'),
          admin: isAdmin,
          manager: isAdmin || canPerformAction('support.manageHours'),
        }}
        refreshKey={refreshKey}
        onNewTicket={canPerformAction('support.viewTickets') ? () => setShowCreateForm(true) : null}
        onArchive={canPerformAction('support.archiveTickets') ? () => setShowArchive(true) : null}
      />
      {showArchive && (
        <ArchiveOldTickets
          apiBase={apiBase}
          getToken={getToken}
          onClose={() => setShowArchive(false)}
          onArchived={triggerRefresh}
        />
      )}
      {showCreateForm && (
        <SupportTicketForm
          apiBase={apiBase}
          getToken={getToken}
          onClose={() => setShowCreateForm(false)}
          onCreated={handleTicketCreated}
        />
      )}
    </div>
  );
}

export default CustomerSupportPage;
